module.exports = __webpack_public_path__ + "static/media/diet.e76fb3e5.jpg";